<template>
  <div :class="['plaindetails-box', `bnf-direction-${direction}`]">
    <!------- direction header strip ------->
    <div class="bnf-direction-header">
      <span class="bnf-direction-icon">
        <i :class="direction === 'departure' ? 'fas fa-plane-departure' : 'fas fa-plane-arrival'" aria-hidden="true"></i>
      </span>
      <span class="bnf-direction-label">{{ direction === 'departure' ? 'טיסת הלוך' : 'טיסת חזור' }}</span>
    </div>
    <!------- direction header strip stop ------->
    <!------- tooltip box start ------->
    <div class='tooltipmainbox'>
      <button class="btn-tooltip" @click="toggleTooltip" v-if="baggagePriceInfo"><i class="fa fa-circle-info"></i></button>
      <div class="tooltip active" v-show="showTooltip">
          <h6>{{ $t("flight-only.baggage-details-title") }}</h6>
          <ul>
            <li v-if="trolleyCostIncluded">
                <img :src="`${speedSizeDomain}/assets/img/img12.png`" alt="trolley" class="icon" />
                {{$t("flight-only.trolley-included", {weight: maxTrolleyWeight})}}
            </li>
            <li v-else>
                <img :src="`${speedSizeDomain}/assets/img/img14.png`" alt="trolley" class="icon" />
                {{$t("flight-only.trolley-not-included", {weight: maxTrolleyWeight})}}
            </li>
            <li v-if="suitcaseCostIncluded">
                <img :src="`${speedSizeDomain}/assets/img/img11.png`" alt="suitcase" class="icon" />
                {{$t("flight-only.suitcase-included", {weight: maxSuitcaseWeight})}}
            </li>
            <li v-else>
                <img :src="`${speedSizeDomain}/assets/img/img11-no.png`" alt="suitcase" class="icon" />
                {{$t("flight-only.suitcase-not-included", {weight: maxSuitcaseWeight})}}
            </li>
          </ul>
      </div>
    </div>
    <!------- tooltip box stop ------->
    <figure class="logo"><img v-if="!flight.FlightDetail[idxFlightDetail].airlineNotConfirmed" :src="logoFlight" alt="" title="" /></figure>
    <div class="plain-date">
      <div class="d-flex justify-content-between align-items-center" v-if="direction === 'departure'">
        <div class="box">
          <h4>{{ departureDate }}</h4>
          <h3>{{ departureTime }}</h3>
          <h4>{{ departureRoute }}</h4>
        </div>
        <figure class="flight-box">
          <img :src="`${speedSizeDomain}/assets/img/app/flight-img1.png`" alt="#" title="" />
        </figure>
        <div class="box">
          <h4>{{ arriveDate }}</h4>
          <h3>{{ arriveTime }}</h3>
          <h4>{{ arriveRoute }}</h4>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center" v-else>
        <div class="box">
          <h4>{{ arriveDate }}</h4>
          <h3>{{ arriveTime }}</h3>
          <h4>{{ arriveRoute }}</h4>
        </div>
        <figure class="flight-box">
          <img class="arrive" :src="`${speedSizeDomain}/assets/img/app/flight-img1.png`" alt="#" title="" />
        </figure>
        <div class="box">
          <h4>{{ departureDate }}</h4>
          <h3>{{ departureTime }}</h3>
          <h4>{{ departureRoute }}</h4>
        </div>
      </div>
    </div>
    <p class="bnf-stopover" v-if="isConnectFlight">{{ $t("flight-only.stopover", { count: 1 }) }}</p>

    <div class="bnf-flight-meta">
      <div class="bnf-carrier">
        <span class="bnf-carrier-name">{{ descriptionFlight }}</span>
        <span class="bnf-flight-code" v-if="codeFlight">{{ codeFlight }}</span>
      </div>
      <p class="bnf-flight-authorize" v-if="authorizeFlight">{{ authorizeFlight }}</p>
    </div>

    <h5 v-if="showSeatsBadge" :class="['bnf-seats-left', minSeats <= 2 ? 'bnf-seats-urgent' : 'bnf-seats-low']">
      <i class="fas fa-bolt" aria-hidden="true"></i>
      {{ seatsMessage }}
    </h5>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import imageUrlMixin from '@/utils/imageUrlMixin';

export default {
  name: 'SingleFlightItemApp',
  mixins: [imageUrlMixin],
  props: {
    flight: {
      type: Object,
      default: null,
    },
    baggagePriceInfo: {
      type: Object,
      default: null,
    },
    showExtraInfo: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'departure',
    },
  },
  data() {
    return {
      showTooltip: false,
      maxSuitcaseWeight: 0,
      maxTrolleyWeight: 0,
    };
  },
  computed: {
    ...mapGetters({
      lang: 'GET_LANGUAGE',
    }),
    idxFlightDetail() {
      return this.direction === 'departure' ? 0 : 1;
    },
    isConnectFlight() {
      return this.flight.FlightDetail[this.idxFlightDetail]?.FL_Flt_Via !== '' ?? false;
    },
    descriptionFlight() {
      return this.flight.FlightDetail[this.idxFlightDetail]?.airlineInfo?.desc1 ?? '';
    },
    codeFlight() {
      return this.flight.FlightDetail[this.idxFlightDetail].airlineNotConfirmed && this.flight.FlightDetail[this.idxFlightDetail].flightTimeNotConfirmed ? '' : `${this.flight.FlightDetail[this.idxFlightDetail].airlineInfo.code || this.flight.FlightDetail[this.idxFlightDetail].FL_AIRLINE} - ${this.flight.FlightDetail[this.idxFlightDetail].FL_Flt_Number}`;
    },
    authorizeFlight() {
      return this.flight.FlightDetail[this.idxFlightDetail].Authorization_msg;
    },
    logoFlight() {
      return (this.flight.FlightDetail[this.idxFlightDetail].airlineInfo && this.flight.FlightDetail[this.idxFlightDetail].airlineInfo.desc2) || `${this.speedSizeDomain}/assets/img/flying.png`;
    },
    departureRoute() {
      return (this.flight.translations && this.flight.translations.flightDestinationName[this.flight.FlightDetail[this.idxFlightDetail].FL_From_Route] && this.flight.translations.flightDestinationName[this.flight.FlightDetail[this.idxFlightDetail].FL_From_Route][this.lang]) || this.flight.FlightDetail[this.idxFlightDetail].FL_From_Route;
    },
    departureDate() {
      return this.formatDate(this.flight.FlightDetail[this.idxFlightDetail].FL_Date);
    },
    departureTime() {
      return this.flight.FlightDetail[this.idxFlightDetail].FL_Dep_Hour;
    },
    arriveRoute() {
      return (this.flight.translations && this.flight.translations.flightDestinationName[this.flight.FlightDetail[this.idxFlightDetail].FL_To_Route] && this.flight.translations.flightDestinationName[this.flight.FlightDetail[this.idxFlightDetail].FL_To_Route][this.lang]) || this.flight.FlightDetail[this.idxFlightDetail].FL_To_Route;
    },
    arriveDate() {
      return this.formatDate(this.flight.FlightDetail[this.idxFlightDetail].landingDate);
    },
    arriveTime() {
      return this.flight.FlightDetail[this.idxFlightDetail].FL_Arrv_Hour;
    },
    trolleyCostIncluded() {
      if (!this.baggagePriceInfo) return true;

      if(this.direction === 'departure') {
        return (this.baggagePriceInfo.trolleyPrice === null);
      } else {
        return (this.baggagePriceInfo.trolleyReturnPrice === null);
      }
    },
    suitcaseCostIncluded() {
      if (!this.baggagePriceInfo) return true;

      if(this.direction === 'departure') {
        return (this.baggagePriceInfo.suitcasePrice === null);
      } else {
        return (this.baggagePriceInfo.suitcasePrice === null);
      }
    },
    minSeats() {
      const a = Number(this.flight.avl1);
      const b = Number(this.flight.avl2);
      return Math.min(Number.isFinite(a) ? a : 99, Number.isFinite(b) ? b : 99);
    },
    seatsMessage() {
      const n = this.minSeats;
      if (n === 1) return 'מקום אחרון! תפסו עכשיו';
      if (n === 2) return 'רק 2 מקומות נותרו';
      if (n === 3) return 'רק 3 מקומות נותרו';
      if (n <= 8) return `רק ${n} מקומות נותרו`;
      return '';
    },
    showSeatsBadge() {
      // Render seats badge only once per round-trip card — on the departure block.
      // The arrive block (direction='arrive') stays clean.
      return this.direction === 'departure' && this.minSeats <= 8;
    },
  },
  created() {
    this.maxTrolleyWeight = +this.flight.FlightDetail[this.idxFlightDetail]?.FL_Max_Weight_Trolley || 0;
    this.maxSuitcaseWeight = this.flight.FlightDetail[this.idxFlightDetail]?.FL_Max_Weight || 0;
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    formatDate(strDate) {
      return dayjs(strDate).format('DD.MM.YY');
    },
  },
};
</script>

<style>
  .heading h1{
    font-weight: bold;
  }
  .plaindetails-box .tooltipmainbox .tooltip.active {
      display: inline-block;
      opacity: 1;
  }
  .plaindetails-box .logo img{
    max-height: 50px;
    width: auto;
  }
  .plaindetails-box .plain-date .flight-box img.arrive{
    -webkit-transform: scaleX(-1);
    translform: scaleX(-1);
  }

  /* ===== Flight meta — restructured carrier/code/authorize for visual hierarchy ===== */
  .plaindetails-box .bnf-flight-meta {
    text-align: center;
    margin: 8px auto 4px;
    padding: 8px 12px;
    line-height: 1.35;
  }
  .plaindetails-box .bnf-carrier {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  .plaindetails-box .bnf-carrier-name {
    font-size: 15px;
    font-weight: 600;
    color: #0e436b;
    letter-spacing: 0.2px;
  }
  .plaindetails-box .bnf-flight-code {
    font-size: 12px;
    color: #6c7a8c;
    background: #f1f5f9;
    border-radius: 4px;
    padding: 2px 8px;
    font-weight: 500;
  }
  .plaindetails-box .bnf-flight-authorize {
    margin: 6px 0 0;
    font-size: 11px;
    color: #94a3b8;
    line-height: 1.35;
  }
  .plaindetails-box .bnf-stopover {
    text-align: center;
    margin: 4px 0;
    font-size: 12px;
    color: #b45309;
    background: #fff8e1;
    border-radius: 4px;
    padding: 4px 10px;
    display: inline-block;
  }

  /* ===== Seats remaining — marketing-toned, single-render per card ===== */
  .plaindetails-box h5.bnf-seats-left {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 12px auto 4px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 999px;
    text-align: center;
    width: auto;
    line-height: 1.2;
  }
  .plaindetails-box h5.bnf-seats-left i {
    font-size: 12px;
  }
  .plaindetails-box h5.bnf-seats-low {
    color: #92400e;
    background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
    border: 1px solid #ffd97a;
  }
  .plaindetails-box h5.bnf-seats-urgent {
    color: #b91c1c;
    background: linear-gradient(135deg, #fff0f0 0%, #ffd6d6 100%);
    border: 1px solid #f5a3a3;
    box-shadow: 0 1px 4px rgba(185, 28, 28, 0.15);
    animation: bnf-seats-pulse 2.4s ease-in-out infinite;
  }
  .plaindetails-box h5.bnf-seats-urgent i {
    color: #dc2626;
  }
  @keyframes bnf-seats-pulse {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 1px 4px rgba(185, 28, 28, 0.15);
    }
    50% {
      transform: scale(1.03);
      box-shadow: 0 2px 8px rgba(185, 28, 28, 0.25);
    }
  }
  /* center the badge horizontally inside its parent flex column */
  .plaindetails-box {
    text-align: center;
  }
  .plaindetails-box h5.bnf-seats-left {
    align-self: center;
  }

  /* ===== Card softening on plaindetails-box (each direction's inner card) ===== */
  .plaindetails-box {
    border-radius: 12px;
    position: relative;
  }

  /* ===== Direction header — modern subtle (R5 B31) ===== */
  /* Was: aggressive full-width strong-color header strip.
     Now: small unobtrusive label-pill in the corner, like Google Flights. */
  .plaindetails-box .bnf-direction-header {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin: 0 0 12px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    text-align: center;
    background: #f1f5f9;
    color: #6c7a8c;
    border: 1px solid #e3e9f1;
    width: fit-content;
    align-self: flex-start;
    line-height: 1.2;
  }
  .plaindetails-box .bnf-direction-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    box-shadow: none;
    width: auto;
    height: auto;
  }
  .plaindetails-box .bnf-direction-icon i {
    font-size: 11px;
  }

  /* Outbound (הלוך) — soft coral accent (no border, no full-width header) */
  .plaindetails-box.bnf-direction-departure {
    border-top: none;
  }
  .plaindetails-box.bnf-direction-departure .bnf-direction-header {
    background: #fff4ec;
    color: #b94a18;
    border-color: #ffd5b8;
  }
  .plaindetails-box.bnf-direction-departure .bnf-direction-icon i {
    color: #fb6d2f;
  }

  /* Return (חזור) — soft blue accent */
  .plaindetails-box.bnf-direction-arrive {
    border-top: none;
  }
  .plaindetails-box.bnf-direction-arrive .bnf-direction-header {
    background: #eef6ff;
    color: #1c4e80;
    border-color: #cfe2ff;
  }
  .plaindetails-box.bnf-direction-arrive .bnf-direction-icon i {
    color: #1c7ed6;
  }

  /* Make plaindetails-box wrapper align children for the new chip pos */
  .plaindetails-box {
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
  }

  @media (max-width: 479px) {
    .plaindetails-box .bnf-direction-header {
      font-size: 10.5px;
      padding: 3px 8px;
    }
    .plaindetails-box .bnf-direction-icon i {
      font-size: 10px;
    }
  }
</style>

<style lang="less" scoped>
  .bonauf-desktop {
    .plaindetails-box {
      .tooltipmainbox {
        .btn-tooltip {
          font-size: 22px;
        }
        .tooltip ul li {
            margin-bottom: 10px;
            font-size: 12px;
            line-height: 20px;
        }
      }
    }
  }
</style>
